import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";
import { toast } from "react-toastify";

import BlueOutlineButton from "src/components/Buttons/BlueOutline";
import Icon from "src/icons";

const Share = () => {
  const handleShare = useCallback(() => {
    const textField = document.createElement("textarea");
    textField.innerText = window.location.href || "";

    if (document.body) {
      document.body.appendChild(textField);
    }
    textField.select();
    document.execCommand("copy");
    textField.remove();

    toast.success(`Copied your current Forms table view`);
  }, []);

  return (
    <BlueOutlineButton
      leftIcon={<Icon type="shareDots" />}
      onClick={handleShare}
    >
      {i18n.t(k.SHARE)}
    </BlueOutlineButton>
  );
};

export default Share;
